import { render, staticRenderFns } from "./CreateSGShardedClusters.vue?vue&type=template&id=21cc2db2&scoped=true"
import script from "./CreateSGShardedClusters.vue?vue&type=script&lang=js"
export * from "./CreateSGShardedClusters.vue?vue&type=script&lang=js"
import style0 from "./CreateSGShardedClusters.vue?vue&type=style&index=0&id=21cc2db2&prod&scoped=true&lang=css"
import style1 from "./CreateSGShardedClusters.vue?vue&type=style&index=1&id=21cc2db2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cc2db2",
  null
  
)

export default component.exports